import iphonePois from "./iphone-pois";
import ipadPois from "./ipad-pois";
import watchPois from "./watch-pois";
var pois = {
  intro: {
    id: "intro",
    name: "Back",
    product: false,
    videos: ["video-iphone", "video-gallery"],
    camera: {
      position: {
        x: -26179.899116097593,
        y: 2361.1774102498343,
        z: 25623.85559909195,
      },
      rotation: {
        x: -2.695667046867381,
        y: -38.974711017773664,
        z: -1.6962698027103205,
      },
      fov: 76,
      wideFov: 45,
      interactive: true,
      clamped: false,
    },
  },
  home: {
    id: "home",
    name: "Back",
    product: false,
    videos: ["video-iphone"],
    camera: {
      position: {
        x: -3400,
        y: 1794.8908619516285,
        z: 0,
      },
      rotation: {
        x: 0,
        y: 0,
        z: 0,
      },
      fov: 76,
      wideFov: 68,
      interactive: true,
      clamped: false,
    },
  },
  game: {
    id: "game",
    name: "FirstRush",
    product: false,
    videos: [],
    camera: {
      position: {
        x: 930.6627246932078,
        y: 1969.3806293047933,
        z: -4579.5559399325375,
      },
      rotation: {
        x: 0,
        y: 180,
        z: 0,
      },
      fov: 76,
      wideFov: 55,
      interactive: true,
      clamped: false,
    },
  },
  video: {
    id: "video",
    name: "Singtel 5G",
    product: false,
    videos: ["video-brand5g"],
    actionButton: "Learn More",
    html: "VideoPage",
    music: false,
    camera: {
      position: {
        x: -3400,
        y: 2037.5186086095841,
        z: -1323.024293890606,
      },
      rotation: {
        x: 0,
        y: 0,
        z: 0,
      },
      fov: 76,
      wideFov: 60,
      interactive: true,
      clamped: false,
    },
  },
  products: {
    id: "products",
    name: "Products",
    product: false,
    backButton: "home",
    videos: ["video-iphone"],
    camera: {
      position: {
        x: -3214.4308054832027,
        y: 1777.3775120954294,
        z: -4077.2141856299118,
      },
      rotation: {
        x: 0,
        y: -90,
        z: 0,
      },
      fov: 82,
      wideFov: 32,
      interactive: true,
      clamped: false,
    },
  },
  gallery: {
    id: "gallery",
    name: "Gallery",
    product: false,
    videos: ["video-gallery"],
    camera: {
      position: {
        x: 2685.5992735136765,
        y: 2200,
        z: -6617.843347205601,
      },
      rotation: {
        x: 0,
        y: 0,
        z: 0,
      },
      fov: 76,
      interactive: true,
      clamped: false,
    },
  },
  addons: {
    id: "addons",
    name: "Add-ons",
    product: false,
    videos: [],
    camera: {
      position: {
        x: 0,
        y: 1741.439742907438,
        z: -2650,
      },
      rotation: {
        x: 0,
        y: 90,
        z: 0,
      },
      fov: 86,
      wideFov: 45,
      interactive: true,
      clamped: false,
    },
  },
  addons1: {
    id: "addons1",
    name: "Add-ons 1",
    backButton: "addons",
    html: "AddonsPage1",
    actionButton: "Learn More",
    product: false,
    videos: [],
    camera: {
      position: {
        x: -6297.96512406417,
        y: 1741.439742907438,
        z: -570.42,
      },
      rotation: {
        x: 0,
        y: 90,
        z: 0,
      },
      fov: 86,
      wideFov: 55,
      interactive: true,
      clamped: false,
    },
  },
  addons2: {
    id: "addons2",
    name: "Add-ons 2",
    backButton: "addons",
    html: "AddonsPage2",
    actionButton: "Learn More",
    product: false,
    videos: [],
    camera: {
      position: {
        x: -6297.96512406417,
        y: 1741.439742907438,
        z: -2943.97,
      },
      rotation: {
        x: 0,
        y: 90,
        z: 0,
      },
      fov: 86,
      wideFov: 55,
      interactive: true,
      clamped: false,
    },
  },
  addons3: {
    id: "addons3",
    name: "Add-ons 3",
    backButton: "addons",
    html: "AddonsPage3",
    actionButton: "Learn More",
    product: false,
    videos: [],
    camera: {
      position: {
        x: -6297.96512406417,
        y: 1741.439742907438,
        z: -5287.8,
      },
      rotation: {
        x: 0,
        y: 90,
        z: 0,
      },
      fov: 86,
      wideFov: 55,
      interactive: true,
      clamped: false,
    },
  },

};

pois = {
  ...pois,
  ...iphonePois,
  ...watchPois,
  ...ipadPois,
};
export default pois;